module.exports = __webpack_public_path__ + "img/status_classify_systems.b95c29b1.gif";